"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentFormSpinner = exports.Spinner = void 0;

var react_1 = __importDefault(require("react"));

require("./Spinner.css");

var BarsCount = 12;
var MaxDegrees = 360;

exports.Spinner = function (props) {
  var bars = [];

  for (var i = 0; i < BarsCount; i += 1) {
    var barStyle = {};
    barStyle.WebkitAnimationDelay = (i - BarsCount) / 10 + " s";
    barStyle.animationDelay = barStyle.WebkitAnimationDelay;
    barStyle.transform = "rotate(" + i * (MaxDegrees / BarsCount) + "deg) translate(146%)";
    barStyle.WebkitTransform = barStyle.transform;
    bars.push(react_1.default.createElement("div", {
      style: barStyle,
      className: (props.color || '') + " bodiless-spinner_bar",
      key: i
    }));
  }

  return react_1.default.createElement("div", {
    className: "bodiless-spinner"
  }, bars);
};

exports.ComponentFormSpinner = function () {
  return react_1.default.createElement("div", {
    className: "bl-pt-3"
  }, react_1.default.createElement(exports.Spinner, {
    color: "bl-bg-white"
  }));
};

exports.default = exports.Spinner;